import { Observable, retry } from 'rxjs';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { API } from '@models/API/index';

import { platformAPI } from '@services/API/endpoints';

@Injectable({ providedIn: 'root' })
export class UsersAPI {
  constructor(private http: HttpClient) {}

  get(
    loaderOptIn: boolean | string = true
  ): Observable<API.Identity.User.Me.Response> {
    return (
      this.http
        .get<API.Identity.User.Me.Response>(platformAPI.identity.users.me, {
          headers: new HttpHeaders({
            'Loader-Opt-In': `${loaderOptIn}`,
            'Auth-Opt-In': 'true',
          }),
        })
        // Retry until we get the data, app can't work without use data
        // 500 millis delay to not bombard the backend with requests
        .pipe(retry({ delay: 500 }))
    );
  }

  patch(
    payload: API.Identity.User.Me.Payload,
    loaderOptIn: boolean | string = true
  ): Observable<API.Identity.User.Me.Response> {
    return this.http.patch<API.Identity.User.Me.Response>(
      platformAPI.identity.users.me,
      payload,
      {
        headers: new HttpHeaders({
          'Loader-Opt-In': `${loaderOptIn}`,
          'Auth-Opt-In': 'true',
        }),
      }
    );
  }
}
